import React from 'react';
import { Button } from 'primereact/button';

/**
 * StudentDetailsView Component
 * 
 * Renders the student details view with left menu panel showing:
 * - Personal Info
 * - Siblings Info
 * - Family Details
 * - Transport Info
 * - Attendance Info
 * 
 * And content area on the right displaying the selected view
 */
export const StudentDetailsView = ({ 
    activeSubMenu,
    studentDetailsMinimized,
    onMenuItemClick,
    onToggleMinimize,
    renderDetailView
}) => {
    return (
        <div className="student-details-section-container">
            <div className={`student-details-layout ${studentDetailsMinimized ? 'minimized' : ''}`}>
                {/* Left Student Details Menu Panel */}
                <div className="student-details-left-menu">
                    <div className="student-details-menu-header">
                        <h3>Student Details</h3>
                        <Button
                            icon={studentDetailsMinimized ? "pi pi-chevron-right" : "pi pi-chevron-left"}
                            className="p-button-text p-button-rounded toggle-btn"
                            onClick={onToggleMinimize}
                            tooltip={studentDetailsMinimized ? "Expand Menu" : "Collapse Menu"}
                            tooltipOptions={{ position: 'right' }}
                        />
                    </div>
                    <div className="student-details-menu-items">
                        <div 
                            className={`student-details-menu-item ${activeSubMenu === 'personalInfo' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showStudentDetailsView: true, 
                                activeDetailView: 'personalInfo', 
                                activeSubMenu: 'personalInfo' 
                            })}
                        >
                            <i className="pi pi-user"></i>
                            <span>Personal Info</span>
                        </div>
                        <div 
                            className={`student-details-menu-item ${activeSubMenu === 'siblingsInfo' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showStudentDetailsView: true, 
                                activeDetailView: 'siblingsInfo', 
                                activeSubMenu: 'siblingsInfo' 
                            })}
                        >
                            <i className="pi pi-users"></i>
                            <span>Siblings Info</span>
                        </div>
                        <div 
                            className={`student-details-menu-item ${activeSubMenu === 'familyDetails' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showStudentDetailsView: true, 
                                activeDetailView: 'familyDetails', 
                                activeSubMenu: 'familyDetails' 
                            })}
                        >
                            <i className="pi pi-users"></i>
                            <span>Family Details</span>
                        </div>
                        <div 
                            className={`student-details-menu-item ${activeSubMenu === 'transportInfo' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showStudentDetailsView: true, 
                                activeDetailView: 'transportInfo', 
                                activeSubMenu: 'transportInfo' 
                            })}
                        >
                            <i className="fa fa-bus"></i>
                            <span>Transport Info</span>
                        </div>
                        <div 
                            className={`student-details-menu-item ${activeSubMenu === 'attendanceInfo' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showStudentDetailsView: true, 
                                activeDetailView: 'attendanceInfo', 
                                activeSubMenu: 'attendanceInfo' 
                            })}
                        >
                            <i className="pi pi-calendar"></i>
                            <span>Attendance Info</span>
                        </div>
                    </div>
                </div>

                {/* Right Student Details Content Area */}
                <div className="student-details-content-area">
                    <div className="student-details-view-container">
                        {renderDetailView()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentDetailsView;
